import { saveTemporaryStorage } from 'utils/useTemporaryStorage';

type PayloadType = {
  listing?:
    | {
        id: string;
        type: string;
        name: string;
      }
    | null
    | undefined;
  subscribedSubsiteId?: string | null | undefined;
};
export const saveTemporaryStorageAndGenerateRedirectURL = async (
  redirectTo: string | null | undefined,
  payload: PayloadType
) => {
  let id = null;

  if (Object.values(payload).filter(Boolean).length > 0) {
    const data = {};

    if (payload.listing) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'SAVE_LISTING' does not exist on type '{}... Remove this comment to see the full error message
      data.SAVE_LISTING = {
        listing: payload.listing,
      };
    }

    if (payload.subscribedSubsiteId) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'SUBSCRIBE_SUBSITE' does not exist on typ... Remove this comment to see the full error message
      data.SUBSCRIBE_SUBSITE = {
        subscribedSubsiteId: payload.subscribedSubsiteId,
      };
    }

    id = await saveTemporaryStorage(data);
  }

  if (redirectTo) {
    const param = redirectTo.includes('?') ? '&tmpId' : '?tmpId';
    return id ? `${redirectTo}${param}=${id}` : redirectTo;
  }

  if (id && window) {
    const url = `${window.location.pathname}${window.location.search}`;
    const param = url.includes('?') ? '&tmpId' : '?tmpId';
    return id ? `${url}${param}=${id}` : redirectTo;
  }

  return null;
};
